import type { SessionUser } from '../../shared/types';

export function homePathForRole(user: SessionUser): string {
  if (user.status === 'pending') return '/pending';
  if (user.mustChangePassword) return '/change-password';
  switch (user.role) {
    case 'plumber':
      return '/referrals';
    case 'dispatch':
      return '/dispatch';
    default:
      return '/jobs';
  }
}
